/**
 * The optics bench's mark: the ray diagram every student draws first — a
 * convex lens, and three parallel rays brought together at its focus.
 *
 * Its own colours, not `currentColor`, like the chemistry lab's flask: the
 * bench's glass and its amber rays, so the mark and the bench agree in either
 * theme.
 */
export function OpticsMark({ size = 26, className }: { size?: number; className?: string }): React.JSX.Element {
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      {/* the principal axis */}
      <path d="M1 12 H23" stroke="#9fb4c8" strokeWidth="0.7" strokeDasharray="1.4 1.1" />
      {/* the lens: two arcs meeting at a point top and bottom */}
      <path d="M12 2.5 Q16.2 12 12 21.5 Q7.8 12 12 2.5 Z"
            fill="#cfe0f0" fillOpacity="0.34" stroke="#9fb4c8" strokeWidth="0.9" strokeLinejoin="round" />
      {/* parallel in, bent at the lens, meeting at the focus */}
      <g fill="none" stroke="#f0a000" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round">
        <path d="M1 6.5 H12 L20.5 12" />
        <path d="M1 12 H20.5" />
        <path d="M1 17.5 H12 L20.5 12" />
      </g>
      <circle cx="20.5" cy="12" r="1.1" fill="#f0a000" />
    </svg>
  );
}
